import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { templatesModel } from '../../../features/templates';

import {
  filterByDraftTemplates,
  filterByPersonalTemplates,
  filterByTeamTemplates,
} from '../../../entities/templates';

export const useSplitTemplates = () => {
  const templates = useSelector(templatesModel.selectors.selectTemplates);

  return useMemo(
    () => ({
      personal: filterByPersonalTemplates(templates),
      team: filterByTeamTemplates(templates),
      drafts: filterByDraftTemplates(templates),
    }),
    [templates]
  );
};
